import { FC } from 'react'
import { useTranslation } from 'next-i18next'
import styles from './index.module.scss'
import { IJobBase } from '../../../types'
import { getDateTimeFromUtc, sanitizeUrl } from '../../../utils'
import { SettingButton } from '../../atoms/SettingButton'
import { SaveJobButton } from '../SaveJobButton'
import { RemoveJobButton } from '../RemoveJobButton'

type Props = {
  job: IJobBase
  isRemovable?: boolean
}

export const JobCardButtonGroup: FC<Props> = ({ job, isRemovable = false }) => {
  const { t } = useTranslation('p')
  const linkToJobDetails = sanitizeUrl(`/jobs/${job?.slug}`)

  return (
    <div>
      <div className={styles.buttonContainer}>
        {isRemovable ? <RemoveJobButton job={job} /> : <SaveJobButton job={job} />}
        <SettingButton componentType='a' color='blue' href={linkToJobDetails}>
          {t('詳細')}
        </SettingButton>
      </div>
      <div className={styles.date}>{getDateTimeFromUtc(job?.createdAt, 'YYYY.MM.DD')}</div>
    </div>
  )
}
